export default class Config {
    env() {
        const config = {
            local: {
                hostname: "localhost",
                // url: "http://localhost:3001",
                url: "https://api-vca.ypc.solutions",
                ws: "ws://localhost:7560",
                environment: "local",
            },
            prod: {
                hostname: "vca.ypc.solutions",
                url: "https://api-vca.ypc.solutions",
                ws: "wss://ws-vca.ypc.solutions",
                environment: "prod",
            },
        };
        return {
            api: config.local.hostname === window.location.hostname ? config.local.url : config.prod.url,
            ws: config.local.hostname === window.location.hostname ? config.local.ws : config.prod.ws,
            environment: config.local.hostname === window.location.hostname ? config.local.environment : config.prod.environment,
        };
    }
}
